module.exports = __webpack_public_path__ + "static/media/remarks.10a23518.svg";